const activeModifier = 'is-sub-nav-active';

const SubNav = class {

    constructor() {
        this.$subNav = $('.js-sub-nav');

        this.$subNav.on('click', '.nav-flyout__caret', (event) => {
            event.preventDefault();
            this.handleToggle(event.delegateTarget);
        });

    }

    handleToggle(subNav) {

        const $currentTarget = $(subNav);

        this.$subNav.not($currentTarget).removeClass(activeModifier);

        if ($currentTarget.hasClass(activeModifier)) {
            $currentTarget.removeClass(activeModifier);
        } else {
            $currentTarget.addClass(activeModifier);
        }

    }
};

new SubNav();
